import React, { useState } from "react";
import axios from "axios";
import Constants from "../Constants";
import Cities from "../Cities.json";
import {
	Alert,
	AlertTitle,
	Box,
	Button,
	Dialog,
	FormControl,
	FormLabel,
	MenuItem,
	Select,
	TextField,
	TextareaAutosize,
	Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import AlertMsg from "../component/AlertMsg";

function AddAdvisorModal({ open, setOpen, addAdvisorApi, addMsg, setAddMsg }) {
	const [loading, setLoading] = useState(false);
	const [checkOpen, setCheckOpen] = useState(false);
	const [checkMsg, setCheckMsg] = useState(false);
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		mobile: "",
		mail: "",
		gender: "",
		capacity: 0,
		bio: "",
		link: "",
		city: "",
		psychologicBio: "",
	});

	const handleInputChange = e => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
	};

	const checkStudent = async () => {
		setAddMsg(null);
		try {
			setLoading(true);
			const response = await axios.post(
				Constants.baseUrl + "/school/advisor/checkStudent",
				{
					mobile: formData.mobile,
				},
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			if (response.data.status === 202) {
				setCheckMsg({
					header: "توجه!",
					message: `با این شماره تلفن، کاربری به نام '${
						(response.data.result.user.firstName
							? response.data.result.user.firstName
							: "کاربر") +
						" " +
						(response.data.result.user.lastName
							? response.data.result.user.lastName
							: "بی نام")
					}' به عنوان دانش‌آموز ثبت شده است. در صورت تایید این پیام ، اکانت دانش‌آموز با این شماره غیرفعال خواهد شد`,
				});
				setCheckOpen(true);
			} else {
				submitButtonHandler();
			}
		} catch (err) {
			setAddMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
			setLoading(false);
		}
	};

	const submitButtonHandler = async () => {
		setLoading(true);
		await addAdvisorApi(formData);
		setLoading(false);
	};

	const inputs = [
		{ id: "firstName", label: "نام", type: "text" },
		{ id: "lastName", label: "نام خانوادگی", type: "text" },
		{ id: "mobile", label: "تلفن همراه", type: "number" },
		{
			id: "gender",
			label: "جنسیت",
			type: "select",
			options: [
				{ value: 1, label: "مرد" },
				{ value: 0, label: "زن" },
			],
		},
		{
			id: "city",
			label: "شهر",
			type: "select",
			options: Cities.map(city => ({ value: city, label: city })),
		},
		{ id: "mail", label: "پست الکترونیکی", type: "email" },
		{ id: "link", label: "لینک ارتباطی", type: "text" },
		{ id: "capacity", label: "ظرفیت تعداد دانش آموز", type: "number" },
		{ id: "bio", label: "توضیحات درباره مشاور", type: "textarea" },
		{
			id: "psychologicBio",
			label: "توضیحات درباره مشاوره روانشناسی",
			type: "textarea",
		},
	];

	return (
		<>
			<Dialog
				fullWidth
				open={open}
				onClose={() => {
					setOpen(false);
					setAddMsg(null);
				}}>
				<Box p={2}>
					<Typography fontSize={18} fontWeight={"bold"} mb={2}>
						افزودن مشاور
					</Typography>

					{inputs.map(input => (
						<FormControl key={input.id} fullWidth margin="normal">
							<FormLabel sx={{ fontWeight: "bold", mb: 0.2 }}>{input.label}</FormLabel>
							{input.type === "textarea" ? (
								<TextareaAutosize
									onChange={handleInputChange}
									name={input.id}
									placeholder={input.label}
									value={formData[input.id] || ""}
									minRows={3}
									style={{ fontFamily: "Iran Sans", padding: "7px" }}
								/>
							) : input.type === "select" ? (
								<Select
									onChange={handleInputChange}
									name={input.id}
									value={formData[input.id] || ""}>
									{input.options.map(option => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</Select>
							) : (
								<TextField
									name={input.id}
									value={formData[input.id]}
									onChange={handleInputChange}
									placeholder={input.label}
									type={input.type}
								/>
							)}
						</FormControl>
					))}
					<LoadingButton
						variant="contained"
						color="secondary"
						onClick={loading ? undefined : checkStudent}
						sx={{ fontSize: "16px", color: "white", my: 1 }}
						loading={loading}>
						افزودن
					</LoadingButton>
					<Button
						variant="contained"
						sx={{ fontSize: "16px", mr: 2, my: 1 }}
						onClick={() => {
							setOpen(false);
							setAddMsg(null);
						}}>
						انصراف
					</Button>
					{addMsg ? (
						addMsg.type ? (
							<AlertMsg message={addMsg} type={"success"} />
						) : (
							<AlertMsg message={addMsg} type={"error"} />
						)
					) : null}
				</Box>
			</Dialog>

			<Dialog fullWidth open={checkOpen}>
				<Box p={2}>
					<Typography fontSize={18} fontWeight={"bold"} mb={2}>
						وجود اکانت با شماره مشابه
					</Typography>
					<Alert
						icon={false}
						severity={"warning"}
						sx={{ alignItems: "flex-start", fontSize: "14px", mt: 0.5 }}>
						<AlertTitle sx={{ fontSize: "16px" }}>{checkMsg.header}</AlertTitle>
						{checkMsg.message}
					</Alert>
					<Button
						variant="contained"
						color="secondary"
						sx={{ fontSize: "16px", mr: 2, my: 1, color: "white" }}
						onClick={() => {
							setCheckOpen(false);
							submitButtonHandler();
						}}>
						تایید
					</Button>
					<Button
						variant="contained"
						sx={{ fontSize: "16px", mr: 2, my: 1 }}
						onClick={() => {
							setLoading(false);
							setCheckOpen(false);
						}}>
						انصراف
					</Button>
				</Box>
			</Dialog>
		</>
	);
}

export default AddAdvisorModal;
